/**
 * @file: 号码申诉
 * @author: wence
 */
import React, {PureComponent} from 'react';
import PropType from 'prop-types';
import {connect} from 'react-redux';
import {Toast} from 'antd-mobile';
import cn from 'classnames';
import {bindActionCreators} from 'redux';
import {FormItem, CodePic} from './formCom';
import {validateRequire, validateMax, validateEmail, validatePhone} from './utils';

import {
    getAlreadyPhoneList,
    validateNumberOwner,
    fetchPersonComplaint,
    fetchCompanyComplaint
} from '../../actions/numberOptionsActions';

import './numberAppeal.less';
const phoneSelect = 'phone_select';
const reasonSelect = 'reason_select';
const otherReason = 'other_reason';

const phoneTypeEnum = {
    tel: '1',
    phone: '2'
};

const appealTypeEnum = {
    person: 'person',
    company: 'company'
};

class NumberAppeal extends PureComponent {
    static propTypes = {
        match: PropType.object,
        history: PropType.object,
        userInfo: PropType.object,
        getAlreadyPhoneList: PropType.func
    }

    constructor(props) {
        super(props);

        const params = this.getParams();
        this.state = {
            params: {
                [phoneSelect]: props.match.params.type !== 'company'
                    ? (params.selectType || phoneTypeEnum.phone)
                    : phoneTypeEnum.phone,
                phone: params.phone,
                [reasonSelect]: 4
            },
            hiddenCodeSendBtn: false,
            tabIndex: props.match.params.type || appealTypeEnum.person,
            phoneNumbers: [],
            phoneList: [],
            fixed: false
        };

        this.validate = {};
        this.numberValidate = [];

        this.onSubmit = this.onSubmit.bind(this);

        if (this.isPC()) {
            window.location.href = `/console/#/appealNumber/${
                props.match.params.type === appealTypeEnum.company ? 'enterprise' : 'personal'
            }?phone=${params.phone || ''}`;
        }
    }

    componentDidUpdate(nextProps) {
        if (nextProps.userInfo !== this.props.userInfo
            && this.props.userInfo
            && this.props.userInfo.status !== 0
        ) {
            const url = location.pathname + location.search;
            const phone = this.getParams().phone;
            window.location.href = `/m/haoma/guide?url=${encodeURIComponent(url)}&phone=${phone || ''}`;
        }
    }

    pushValidate(key, node) {
        if (node) {
            this.validate[key] = node.validate;
        }
    }

    async onSubmit() {
        let canSubmit = true;

        Object.keys(this.validate).map(valiKey => {
            const vilidate = this.validate && this.validate[valiKey]();

            if (vilidate.validate && canSubmit) {
                canSubmit = false;
            }
        });

        if (canSubmit) {
            let postParams = {};
            const {tabIndex, params} = this.state;
            if (tabIndex === appealTypeEnum.person && phoneTypeEnum.phone === params[phoneSelect]) {
                postParams = {
                    [phoneSelect]: params[phoneSelect],
                    phone: params.phone,
                    [reasonSelect]: params[reasonSelect],
                    code: params.code
                };
            }

            if (tabIndex === appealTypeEnum.person && phoneTypeEnum.tel === params[phoneSelect]) {
                postParams = {
                    [phoneSelect]: params[phoneSelect],
                    phone: params.phone,
                    [reasonSelect]: params[reasonSelect],
                    email: params.email || '',
                    captcha: params.captcha,
                    certificates: this.state.certificates
                };
            }

            if (tabIndex === appealTypeEnum.company) {
                postParams = {
                    [phoneSelect]: params[phoneSelect],
                    [reasonSelect]: params[reasonSelect],
                    email: params.email || '',
                    captcha: params.captcha,
                    certificates: this.state.certificates,
                    certificates2: this.state.certificates2
                };

                postParams.phone = [params.phone].concat(this.state.phoneNumbers).join(',');
            }


            if (params[otherReason]) {
                postParams[otherReason] = params[otherReason];
            }

            const formData = new FormData();

            Object.keys(postParams).forEach(postParamsKey => {
                formData.append(postParamsKey, postParams[postParamsKey]);
            });

            if (tabIndex === appealTypeEnum.person) {
                const personRes = await fetchPersonComplaint(formData);

                if (personRes.status === 0) {
                    window.location.href = `/m/haoma/success/appeal/person/${params[phoneSelect]}`;
                    return;
                }
                else if (personRes.status === 401) {
                    window.location.href = this.loginUrl();
                }
                else if (postParams[phoneSelect] === phoneTypeEnum.phone) {
                    Toast.info(personRes.description, 2);
                }
                else {
                    if (personRes && personRes.description) {
                        Toast.info(personRes.description, 2);
                    }
                    this.codePic.resetCode();
                    this.resetCaptcha();
                }
            }

            if (tabIndex === appealTypeEnum.company) {
                const companyRes = await fetchCompanyComplaint(formData);

                if (companyRes.status === 0) {
                    window.location.href = '/m/haoma/success/appeal/company';
                    return;
                }
                else if (companyRes.status === 401) {
                    window.location.href = this.loginUrl();
                }
                else {
                    if (companyRes && companyRes.description) {
                        Toast.info(companyRes.description, 2);
                    }
                    this.codePic.resetCode();
                    this.resetCaptcha();
                }
            }
        }
    }

    resetCaptcha = () => {
        this.setState({params: {...this.state.params, captcha: ''}});
    }

    onChange(key, value, file) {
        this.setState({params: {...this.state.params, [key]: value}});

        if (key === 'certificates' || key === 'certificates2') {
            this.setState({[key]: file});
        }

        if (key === phoneSelect) {
            this.validate = {};

            this.props.history.replace(`/haoma/appeal/${this.state.tabIndex}?selectType=${value}`);
        }
    }

    onChangeTabIndex = tabIndex => {
        this.setState({tabIndex});
        this.validate = {};

        this.props.history.replace(`/haoma/appeal/${tabIndex}?selectType=${this.state.params[phoneSelect]}`);
    }

    task = fn => {
        let run = true;

        if (run) {
            fn(() => {
                this.timer = setTimeout(() => this.task(fn), 1000);
            });
        }

        return () => {
            run = false;
            this.timer = null;
        };
    }

    sendCode = async () => {
        const phoneValidate = this.validate.phone();
        const phoneNumber = this.state.params.phone;
        const hasValidate = (this.state.phoneList || []).some(item => item === phoneNumber);

        if (hasValidate) {
            this.validate.phone({validate: true, message: '号码已在审核中！'});
            return;
        }

        if (phoneValidate && phoneValidate.validate) {
            this.validate.code({validate: true, message: '请输入正确的手机号'});
        }
        else {
            this.validate.code({validate: false, message: ''});

            const res = await validateNumberOwner({
                action: 'mobile',
                type: 2,
                mobile: this.state.params.phone
            });

            if (res.status === 0 && res.data.status === 1) {
                this.setState({hiddenCodeSendBtn: true, codeResendTime: 61});

                this.task(callback => {
                    const codeResendTime = this.state.codeResendTime;
                    if (codeResendTime <= 0) {
                        this.timer = null;

                        this.setState({hiddenCodeSendBtn: false});
                        return;
                    }

                    this.setState({codeResendTime: codeResendTime - 1}, callback);
                });
            }
        }
    }

    addPhoneNumber = () => {
        const curValue = this.state.phoneNumbers.slice(0);
        curValue.push('');
        this.setState({phoneNumbers: curValue});
    }

    deleteNumber(index) {
        const curValue = this.state.phoneNumbers.slice(0);

        curValue.splice(index, 1);
        this.setState({phoneNumbers: curValue});

        this.validate = {};
    }

    onPhoneNumberChange(index, value) {
        const curValue = this.state.phoneNumbers.slice(0);
        curValue[index] = value;

        this.setState({phoneNumbers: curValue});
    }

    renderMorePhone = () => {
        const phoneNumbers = this.state.phoneNumbers;
        const len = phoneNumbers.length;
        const disableAdd = len >= 4;
        const self = this;
        return (
            <div>
                {phoneNumbers.map((phoneNumber, index) => {
                    return (
                        <FormItem
                            key={index}
                            isRequire
                            type="input"
                            noLabel
                            className="more-input-wrapper"
                            placeholder="请输入您要申诉的号码"
                            comClassName="form-input more-input"
                            renderRight={() => {
                                return (
                                    <div onClick={this.deleteNumber.bind(this, index)} className="delete-number">
                                        <img src={require('../../asset/svg/icon_delete.svg')} alt="" />
                                    </div>
                                );
                            }}
                            ref={this.pushValidate.bind(this, `phone${index + 2}`)}
                            value={phoneNumber}
                            onChange={this.onPhoneNumberChange.bind(this, index)}
                            onFocus={this.getAlreadyPhoneList}
                            onBlur={this.onBlur}
                            rules={[...validatePhone('申诉号码', true), {
                                validate(value) {
                                    return self.state.phoneList.some(item => {
                                        return item === value;
                                    });
                                },
                                message: '号码已在审核中！'
                            }]}
                        />
                    );
                })}
                <div
                    onClick={!disableAdd ? this.addPhoneNumber : () => null}
                    className={cn('phone-number-add', {disabled: disableAdd})}>
                    <img src={
                        disableAdd
                            ? require('../../asset/svg/icon_addinbtn_disable.svg')
                            : require('../../asset/svg/icon_addinbtn.svg')} alt="" />
                    新增一个
                </div>
            </div>
        );
    }
    renderRight = () => {
        const hiddenCodeSendBtn = this.state.hiddenCodeSendBtn;
        return (
            <div className="phone-code">
                {hiddenCodeSendBtn
                    ? <span className="task-tips">{this.state.codeResendTime}秒后重新获取</span>
                    : <span onClick={this.sendCode}>发送验证码</span>}
            </div>
        );
    }

    getAlreadyPhoneList = async () => {
        this.onFocus();
        const phoneListRes = await this.props.getAlreadyPhoneList();
        if (phoneListRes.status === 0) {
            this.setState({phoneList: phoneListRes.data});
        }
        else if (phoneListRes.status === 401) {
            window.location.href = this.loginUrl();
        }
    }

    onBlur = () => {
        if (this.isIOS) {
            this.setState({fixed: false});

            document.querySelector('.nav-bar').style.position = '';
        }

    }

    onFocus = () => {
        if (this.isIOS) {
            this.setState({fixed: true});

            document.querySelector('.nav-bar').style.position = 'absolute';
        }
    }

    getTypeData = () => {
        if (this.state.tabIndex === appealTypeEnum.company) {
            return [
                {label: '标记为诈骗、骚扰等类型', value: 4},
                {label: '号码的企业信息有误 ', value: 1},
                {label: '不希望显示企业信息', value: 2},
                {label: '该号码非本企业号码', value: 5}
            ];
        }

        return [
            {label: '标记为诈骗、骚扰等类型', value: 4},
            {label: '号码被标记为企业名称', value: 1}
        ];
    }

    render() {
        const {params, tabIndex} = this.state;
        return (
            <div className="number-appeal">
                <div className={cn('number-appeal-tab', {fixed: this.state.fixed})}>
                    <div
                        onClick={this.onChangeTabIndex.bind(this, appealTypeEnum.person)}
                        className={cn('tab-item', {active: tabIndex === appealTypeEnum.person})}>
                        个人号码申诉
                        <div className="tab-stick"></div>
                    </div>
                    <div
                        onClick={this.onChangeTabIndex.bind(this, appealTypeEnum.company)}
                        className={cn('tab-item', {active: tabIndex === appealTypeEnum.company})}>
                        企业号码申诉
                        <div className="tab-stick"></div>
                    </div>
                </div>
                <div className="number-appeal-wrapper">
                    <div className="form">
                        {tabIndex === appealTypeEnum.person
                            && <FormItem
                                isRequire
                                type="select"
                                label="号码类型："
                                placeholder="电话号码"
                                value={this.state.params[phoneSelect]}
                                onChange={this.onChange.bind(this, phoneSelect)}
                                ref={this.pushValidate.bind(this, phoneSelect)}
                                onBlur={this.onBlur}
                                onFocus={this.onFocus}
                                data={[
                                    {label: '手机号码 ', value: phoneTypeEnum.phone},
                                    {label: '座机号码', value: phoneTypeEnum.tel}
                                ]}
                            />}
                        <FormItem
                            isRequire
                            type="input"
                            label="申诉号码："
                            des={tabIndex === appealTypeEnum.company ? '请输入座机、手机、座机格式：010-12345678' : ''}
                            placeholder={
                                tabIndex === appealTypeEnum.company
                                    ? '请输入您要申诉的号码'
                                    : (params[phoneSelect] === phoneTypeEnum.phone
                                        ? '请输入手机号码'
                                        : '请输入座机号码、座机格式：010-12345678')
                            }
                            comClassName="form-input"
                            ref={this.pushValidate.bind(this, 'phone')}
                            value={this.state.params.phone}
                            onChange={this.onChange.bind(this, 'phone')}
                            onFocus={this.getAlreadyPhoneList}
                            onBlur={this.onBlur}
                            rules={validatePhone(
                                '申诉号码',
                                tabIndex === appealTypeEnum.company || params[phoneSelect] === phoneTypeEnum.tel,
                                this.state.phoneList)}
                        />
                        {tabIndex === appealTypeEnum.company && this.renderMorePhone()}
                        {params[phoneSelect] === phoneTypeEnum.phone
                            && tabIndex === appealTypeEnum.person
                            && <div>
                                <FormItem
                                    type="input"
                                    isRequire
                                    label="验证码："
                                    comClassName="form-input code"
                                    rules={[validateRequire('验证码')]}
                                    ref={this.pushValidate.bind(this, 'code')}
                                    value={this.state.params.code}
                                    onChange={this.onChange.bind(this, 'code')}
                                    placeholder="请输入验证码"
                                    renderRight={this.renderRight}
                                    onBlur={this.onBlur}
                                    onFocus={this.onFocus}
                                />
                            </div>}
                        <FormItem
                            isRequire
                            type="select"
                            label="申诉理由："
                            placeholder="标记为诈骗、骚扰等类型"
                            data={this.getTypeData()}
                            ref={this.pushValidate.bind(this, reasonSelect)}
                            value={this.state.params[reasonSelect]}
                            onChange={this.onChange.bind(this, reasonSelect)}
                        />
                        <FormItem
                            type="textarea"
                            label="其他理由："
                            placeholder="其他理由（100字以内）"
                            rows={3}
                            comClassName="form-textarea"
                            ref={this.pushValidate.bind(this, otherReason)}
                            rules={[validateMax('其他理由', 100)]}
                            value={this.state.params[otherReason]}
                            onChange={this.onChange.bind(this, otherReason)}
                            onBlur={this.onBlur}
                            onFocus={this.onFocus}
                        />
                        {params[phoneSelect] === phoneTypeEnum.tel && tabIndex !== appealTypeEnum.company
                            && <FormItem
                                type="upload"
                                isRequire
                                name="certificates"
                                label="添加证明 ："
                                labelName="添加证明"
                                des="申诉号码的开户证明，缴费证明，网页截图等有效证明，任选其一图片支持jpg或png格式，大小不超过1M"
                                fileType="image/png;image/jpg"
                                fileSize={1024 * 1024}
                                ref={this.pushValidate.bind(this, 'certificates')}
                                rules={[validateRequire('添加证明')]}
                                value={this.state.params.certificates}
                                onChange={this.onChange.bind(this, 'certificates')}
                            />}
                        {tabIndex === appealTypeEnum.company
                            && <FormItem
                                type="upload"
                                isRequire
                                name="certificates2"
                                label="企业合法资质："
                                labelName="企业合法资质"
                                des="最新年检的企业营业执照，组织机构代码证，税务证书（三选一）图片支持jpg或png格式，大小不超过1M"
                                fileType="image/png;image/jpg"
                                fileSize={1024 * 1024}
                                ref={this.pushValidate.bind(this, 'certificates')}
                                rules={[validateRequire('企业合法资质')]}
                                value={this.state.params.certificates}
                                onChange={this.onChange.bind(this, 'certificates')}
                            />}
                        {tabIndex === appealTypeEnum.company
                            && <FormItem
                                type="upload"
                                isRequire
                                name="certificates1"
                                label="运营商证明："
                                labelName="运营商证明"
                                des="认证号码的开户证明，缴费证明等有效证明，选其一即可 图片支持jpg或png格式，大小不超过1M"
                                fileType="image/png;image/jpg"
                                fileSize={1024 * 1024}
                                ref={this.pushValidate.bind(this, 'certificates2')}
                                rules={[validateRequire('运营商证明')]}
                                value={this.state.params.certificates2}
                                onChange={this.onChange.bind(this, 'certificates2')}
                            />}
                        {(params[phoneSelect] === phoneTypeEnum.tel || tabIndex === appealTypeEnum.company)
                            && <FormItem
                                type="input"
                                label="联系邮箱："
                                comClassName="form-input"
                                value={this.state.params.email}
                                onChange={this.onChange.bind(this, 'email')}
                                placeholder="请输入您的邮箱"
                                ref={this.pushValidate.bind(this, 'email')}
                                rules={validateEmail()}
                                onBlur={this.onBlur}
                                onFocus={this.onFocus}
                            />}
                        {(params[phoneSelect] === phoneTypeEnum.tel || tabIndex === appealTypeEnum.company)
                            && <div>
                                <FormItem
                                    type="input"
                                    label="验证码："
                                    comClassName="form-input code"
                                    value={this.state.params.captcha}
                                    onChange={this.onChange.bind(this, 'captcha')}
                                    onBlur={this.onBlur}
                                    onFocus={this.onFocus}
                                    placeholder="请输入验证码"
                                    ref={this.pushValidate.bind(this, 'captcha')}
                                    rules={[validateRequire('验证码')]}
                                    renderRight={() => <CodePic
                                        resetCaptcha={this.resetCaptcha}
                                        ref={codePic => this.codePic = codePic} />}
                                />
                            </div>}
                        <div onClick={this.onSubmit} className="number-options-btn">提交申诉</div>

                        <p className="submit-tips">提交申诉后，会在2个工作日审核完毕</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        userInfo: state.userLoginstate
    }),
    dispatch => bindActionCreators({getAlreadyPhoneList}, dispatch)
)(NumberAppeal);



// WEBPACK FOOTER //
// ./src/containers/numberOptions/numberAppeal.js